<template>
    <v-dialog v-model="showDialog" :max-width="showConfirmation ? '600px' : '1140px'" persistent
        :overlay-opacity="showConfirmation ? 0.8 : 1" overlay-color="#8A8A8A">
        <v-card class="rounded-xl" style="position: relative;">
            <v-btn icon small @click="handleConfirmClose"
                style="position: absolute; top: 8px; right: 8px; z-index: 10;">
                <v-icon>mdi-close</v-icon>
            </v-btn>

            <div class="pa-6">

                <div v-if="!showConfirmation">
                    <v-card-title class="d-flex flex-column align-center text-center">
                        <div class="font-roboto text-h4 tex-center mb-2 plusGreyDarken2--text">
                            {{ $t('message.migration_call_title') }}
                        </div>
                        <div class="font-roboto text-h6 plusTextSecondary--text text-center">
                            {{ $t('message.migration_call_description') }}
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <!-- Calendly inline widget begin -->
                                    <div id="calendly-inline-widget" class="calendly-inline-widget"
                                        data-url="https://calendly.com/rodrigocostamatos2211/30min"
                                        :hidden="showConfirmation" style="min-width:500px;height:700px;"></div>

                                    <!-- Calendly inline widget end -->
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </div>

                <div v-else>
                    <v-card-title class="d-flex flex-column align-center text-center">
                        <div class="font-roboto text-h4 tex-center mb-2 plusGreyDarken2--text">
                            {{ $t('message.migration_call_booked_title') }}
                        </div>
                        <div class="font-roboto text-h6 plusTextSecondary--text text-center">
                            {{ $t('message.migration_call_booked_description') }}
                        </div>
                    </v-card-title>

                    <v-card-text v-if="eventDetails" class="">
                        <div class="container-confirmation-details">

                            <v-container class="mt-4">
                                <v-row>
                                    <v-col cols="6" class="d-flex flex-column">
                                        <v-card tile color="plusBackground" elevation="0" class="flex-grow-1 mb-5">
                                            <v-card-text>
                                                <v-row>
                                                    <v-col class="text-center">
                                                        <v-icon size="32" color="plusPrimary">mdi-calendar</v-icon>
                                                        <div class="text-caption  plusTextSecondary--text">
                                                            {{ $t('message.migration_date') }}</div>
                                                        <div class="text-body-1 font-weight-medium">{{ eventDetails.date
                                                            }}</div>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>

                                        <v-card elevation="0" color="plusBackground" class="flex-grow-1">
                                            <v-card-text>
                                                <v-row>
                                                    <v-col class="text-center">
                                                        <v-icon size="32" color="plusPrimary">mdi-av-timer</v-icon>
                                                        <div class="text-caption  plusTextSecondary--text">
                                                            {{ $t('message.migration_duration') }}</div>
                                                        <div class="text-body-1 font-weight-medium">{{
                                                            eventDetails.duration }}</div>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="6" class="d-flex flex-column">
                                        <v-card elevation="0" color="plusBackground" class="flex-grow-1 mb-5">
                                            <v-card-text>
                                                <v-row>
                                                    <v-col class="text-center">
                                                        <v-icon size="32"
                                                            color="plusPrimary">mdi-clock-time-five-outline</v-icon>
                                                        <div class="text-caption  plusTextSecondary--text">
                                                            {{ $t('message.migration_time') }}</div>
                                                        <div class="text-body-1 font-weight-medium">
                                                            {{ eventDetails.time }}</div>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>

                                        <v-card elevation="0" color="plusBackground" class="flex-grow-1">
                                            <v-card-text>
                                                <v-row>
                                                    <v-col class="text-center">
                                                        <v-icon size="32" color="plusPrimary">mdi-message-video</v-icon>
                                                        <div class="text-caption  plusTextSecondary--text">{{
                                                            $t('message.migration_format') }}</div>
                                                        <div class="text-body-1 font-weight-medium">{{
                                                            $t('message.migration_video_call') }}</div>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>

                                </v-row>

                                <v-card elevation="0" color="plusIndigoLighten5" class="mt-5">
                                    <v-row>
                                        <v-col class="text-center">
                                            <div class="text-body-1 font-weight-medium">{{ $t('message.migration_host')
                                                }}: {{ eventDetails.name }} +
                                                {{
                                                    eventDetails.hostName }}</div>
                                        </v-col>
                                    </v-row>
                                </v-card>


                            </v-container>
                        </div>
                        <div class="mt-5 pa-3">
                            <div class="font-roboto text-h6 mb-4">{{ $t('message.migration_what_to_expect') }}</div>
                            <v-col class="d-flex flex-column mb-8">
                                <v-row class="align-center mb-1">
                                    <v-icon color="plusGreenAccent4" class="mr-2">
                                        mdi-check-circle-outline
                                    </v-icon>
                                    <div>
                                        {{ $t('message.migration_expect_1') }}
                                    </div>
                                </v-row>
                                <v-row class="align-center mb-1">
                                    <v-icon color="plusGreenAccent4" class="mr-2">
                                        mdi-check-circle-outline
                                    </v-icon>
                                    <div>
                                        {{ $t('message.migration_expect_2') }}
                                    </div>
                                </v-row>
                                <v-row class="align-center mb-1">

                                    <v-icon color="plusGreenAccent4" class="mr-2">
                                        mdi-check-circle-outline
                                    </v-icon>
                                    <div>
                                        {{ $t('message.migration_expect_3') }}
                                    </div>

                                </v-row>
                                <v-row class="align-center mb-1">

                                    <v-icon color="plusGreenAccent4" class="mr-2">
                                        mdi-check-circle-outline
                                    </v-icon>
                                    <div>
                                        {{ $t('message.migration_expect_4') }}
                                    </div>

                                </v-row>
                                <v-row class="align-center mb-1">
                                    <v-icon color="plusGreenAccent4" class="mr-2">
                                        mdi-check-circle-outline
                                    </v-icon>
                                    <div>
                                        {{ $t('message.migration_expect_5') }}
                                    </div>
                                </v-row>
                            </v-col>


                            <div class="font-roboto text-h6 mb-4">{{ $t('message.migration_while_you_wait') }}</div>

                            <p class=" font-roboto text-subtitle-1 plusTextSecondary--text">
                                {{ $t('message.migration_while_you_wait_text') }}
                            </p>
                        </div>
                    </v-card-text>


                    <v-card-actions class="justify-center pb-4">
                        <v-btn color="plusIndigoDarken2"
                            class="px-12 rounded plusTextOnSecondary--text font-roboto-semi-bold" large
                            @click="handleConfirmClose">
                            {{ $t('message.migration_explore_workspace') }}
                        </v-btn>
                    </v-card-actions>
                </div>

                <!-- Loading -->
                <v-overlay v-if="isLoading" absolute>
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </div>
        </v-card>
    </v-dialog>
</template>


<script setup>
import { ref, onMounted, onUnmounted, defineEmits } from "vue";
import axios from "axios";
import { Environment } from "../../services/Environment";
import { VCard } from "vuetify/lib";

const emit = defineEmits(['close', 'confirm']);

const showConfirmation = ref(false);
const eventDetails = ref(null);
const isLoading = ref(false);

const handleConfirmClose = () => {
    showConfirmation.value = false;
    eventDetails.value = null;
    emit('close');
};

/**
 * @param {string} eventUri 
 */
const fetchCalendlyEventDetails = async (eventUri) => {
    try {
        isLoading.value = true;

        const response = await axios.get(eventUri, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Environment.get("VUE_APP_CALENDLY_API_KEY")
            }
        });

        const result = response.data.resource;


        const dateDetails = formatDateDetailsMeeting(result.start_time, result.end_time);

        eventDetails.value = {
            date: dateDetails.date,
            time: dateDetails.time,
            duration: dateDetails.duration,
            dateStart: result.start_time,
            dateEnd: result.end_time,
            name: result.name,
            hostName: result.event_memberships?.[0]?.user_name || "Unknown",
        };

        showConfirmation.value = true;

        const calendlyWidget = document.querySelector('iframe');
        if (calendlyWidget) {
            calendlyWidget.remove();
        }
    } catch (error) {
        console.error('Erro retrieving event details:', error);

    } finally {
        isLoading.value = false;
    }
};

/**
 * @param {string} dateStartString
 * @param {string} dateEndString
 * @return {{date: string, time: string, duration: string   }} 
 */
const formatDateDetailsMeeting = (dateStartString, dateEndString) => {
    if (!dateStartString || !dateEndString) return { date: 'Unknown', time: 'Unknown', duration: 'Unknown' };
    const startDate = new Date(dateStartString);
    const endDate = new Date(dateEndString);
    const month = String(startDate.getMonth() + 1).padStart(2, '0');
    const day = String(startDate.getDate()).padStart(2, '0');
    const year = startDate.getFullYear();
    const startTime = `${String(startDate.getHours()).padStart(2, '0')}:${String(startDate.getMinutes()).padStart(2, '0')}`;
    const endTime = `${String(endDate.getHours()).padStart(2, '0')}:${String(endDate.getMinutes()).padStart(2, '0')}`;
    return { date: `${month}/${day}/${year}`, time: `${startTime}`, duration: calculateDuration(startDate, endDate) };
};

/**
 * @param {Date} startDate 
 * @param {Date} endDate 
 */
const calculateDuration = (startDate, endDate) => {
    const diffMs = endDate - startDate;
    const diffMins = Math.round(diffMs / 60000);
    return `${diffMins} min`;
}

/**
 * @param {MessageEvent} event 
 */
const calendlyEventHandler = (event) => {

    if (event.origin !== 'https://calendly.com') return

    const calendlyData = event.data || {}

    if (!calendlyData.event?.startsWith('calendly.')) return

    if (calendlyData.event === 'calendly.event_scheduled') {
        const eventUri = calendlyData.payload?.event?.uri;

        if (eventUri) {
            fetchCalendlyEventDetails(eventUri);
        }
    }
}

onMounted(() => {

    window.removeEventListener('message', calendlyEventHandler);
    window.addEventListener('message', calendlyEventHandler);

    const initializeCalendly = () => {
        if (window.Calendly) {

            const widgetElement = document.getElementById('calendly-inline-widget');
            if (widgetElement) {
                widgetElement.innerHTML = '';
                window.Calendly.initInlineWidget({
                    url: Environment.get('VUE_APP_CALENDLY_URL'),
                    parentElement: widgetElement
                });
            }
        }
    };

    const existingScript = document.querySelector('script[src*="calendly.com/assets/external/widget.js"]');

    if (!existingScript) {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        script.onload = initializeCalendly;
        document.body.appendChild(script);
    } else {
        if (window.Calendly) {
            initializeCalendly();
        } else {
            const checkCalendly = setInterval(() => {
                if (window.Calendly) {
                    clearInterval(checkCalendly);
                    initializeCalendly();
                }
            }, 100);
        }
    }
});

onUnmounted(() => {
    window.removeEventListener('message', calendlyEventHandler)
})
</script>

<script>
export default {
    name: "MigrationFromAnotherSystem",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        showDialog: {
            get() {
                return this.show;
            },
            /**
             * @param {boolean} value 
             */
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        handleCancel() {
            this.$emit("close");
        },
        handleConfirm() {
            this.$emit("confirm");
        },
    },
};
</script>

<style scoped>
.container-confirmation-details {
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    background-color: #FFFFFF;
}

.v-card {
    border-radius: 30px !important;
}
</style>
